@if (asset.customFields) {
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['rang1']">
    <span class="dataset-entry-label w-2/5 field-label">Klasse 1</span>
    <div class="dataset-entry-value inline-block w-3/5">
      <span>{{ asset.customFields['rang1'] === 'fallback' ? 'Fallback' : asset.customFields['rang1'] + ' Mio.' }} </span>
    </div>
  </div>
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['rang2']">
    <span class="dataset-entry-label w-2/5 field-label">Klasse 2</span>
    <div class="dataset-entry-value inline-block w-3/5">
      <span>{{ asset.customFields['rang2'] === 'fallback' ? 'Fallback' : asset.customFields['rang2'] + ' Mio.' }} </span>
    </div>
  </div>
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['nextDrawingDay']">
    <span class="dataset-entry-label w-2/5 field-label">Ziehung</span>
    <div class="dataset-entry-value inline-block w-3/5" [ngSwitch]="asset.customFields['nextDrawingDay']">
      <span *ngSwitchCase="'tuesday'">Dienstag</span>
      <span *ngSwitchCase="'friday'">Freitag</span>
      <span *ngSwitchCase="'tuesdaysAndFridays'">Dienstag &amp; Freitag</span>
      <span *ngSwitchCase="'today'">Am Ziehungstag</span>
      <span *ngSwitchDefault>Unbekannter Wert: {{ asset.customFields['nextDrawingDay'] }}</span>
    </div>
  </div>
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['region']">
    <span class="dataset-entry-label w-2/5 field-label">Region</span>
    <div class="dataset-entry-value inline-block w-3/5">
      <span>{{ asset.customFields['region'] }}</span>
    </div>
  </div>
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['motif']">
    <span class="dataset-entry-label w-2/5 field-label">Motif</span>
    <div class="dataset-entry-value inline-block w-3/5">
      <span>{{ asset.customFields['motif'] }}</span>
    </div>
  </div>
  <div class="dataset-entry flex row items-start" *ngIf="asset.customFields['length']">
    <span class="dataset-entry-label w-2/5 field-label">Länge</span>
    <div class="dataset-entry-value inline-block w-3/5">
      <span>{{ asset.customFields['length'] }} Sekunden</span>
    </div>
  </div>
}
